export default function (state={}, action) {
	switch(action.type) {
		case "SELECTED_CONTAINER_DATA":
			return action.payload;

		default:
			return state;
	}
}